import { getGlobalThis } from "./GetGlobalThis.js";
function getGlobalProperty(property, defaultValue) {
  const global = getGlobalThis();
  return global[property] ?? defaultValue;
}
export {
  getGlobalProperty
};
//# sourceMappingURL=GetGlobalProperty.js.map
